export interface LogoProps {
  type?: "text" | "icon";
  className?: string;
  w?: number;
  h?: number;
}

const getWidthAndHeight = (
  kind: LogoProps["type"],
  w: number | undefined,
  h: number | undefined,
) => {
  return {
    width: w || kind === "icon" ? 80 : 120,
    height: h || kind === "icon" ? 80 : 40,
  };
};

const Logo = (props: LogoProps) => {
  const { type = "text", className = "", w, h } = props;

  const { width, height } = getWidthAndHeight(type, w, h);

  const imagePath = `${import.meta.env.VITE_WIDGET_BASE_URL}/${type}-logo-light.png`;
  const altText = type === "text" ? "Testify" : "Testify Icon";

  return (
    <a href={`${import.meta.env.VITE_WEBSITE_URL}`}>
      <img
        src={imagePath}
        alt={altText}
        width={width}
        height={height}
        className={className}
      />
    </a>
  );
};

export default Logo;
